import {hrmsWithPath} from "../../services/http/api/rest";
import {Login, ResetPassword, ChangePassword} from "../../domains/models/auth";

const rest = hrmsWithPath("/v1/auth");

const auth = {
    login: (data: Login) => rest.post('/login', {}, data),
    logout: (token: string) => rest.post(
        '/logout',
        {},
        {},
        {},
        {
            "Authorization": token
        }
    ),
    sendOtp: (email: string) => rest.post('/otp/send', {}, {}, {"email": email}),
    verifyOtp: (email: string, otp: string) => rest.post(
        '/otp/validate',
        {},
        {},
        {
            "email": email,
            "otp": otp
        }),
    resetPassword: (data: ResetPassword) => rest.put('/reset', {}, data),
    refreshToken: (token: string) => rest.post(`/refresh`, {}, {refreshToken:token}, {}),
}

export default auth;
